import { PrivateRoomData } from "./get-privateroom.types";
import { apiWobaInventory } from "@/services/api-woba-inventory";
import _ from "lodash";

const customSnakeCase = (str: string): string => {
  return str
    .replace(/([a-z])([A-Z])/g, "$1_$2")
    .replace(/([A-Z])([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();
};

export const toSnakeCase = (obj: unknown): unknown => {
  if (obj === null || typeof obj !== "object") {
    return obj;
  }
  if (Array.isArray(obj)) {
    return obj.map((v) => toSnakeCase(v));
  }

  const record = obj as Record<string, unknown>;

  return Object.keys(record).reduce((acc: Record<string, unknown>, key) => {
    const snakeKey = customSnakeCase(key);
    const value = record[key];
    acc[snakeKey] = toSnakeCase(value);
    return acc;
  }, {});
};

export const GetPrivateRoomApi = async ({
  id,
}: {
  id: number | string;
}): Promise<PrivateRoomData> => {
  let dataResponse: PrivateRoomData;
  try {
    const response = await apiWobaInventory.get(
      `/private-offices/${id}/amenities`,
    );
    const converted = toSnakeCase(response.data);

    if (
      !converted ||
      typeof converted !== "object" ||
      !("private_office" in converted)
    ) {
      throw new Error(`Invalid response structure from inventory API`);
    }

    dataResponse = converted as PrivateRoomData;
  } catch (e) {
    console.error(`Failed to fetch private room ${id}:`, e);
    throw e;
  }

  const convertStringToArray = (text: string | string[]) => {
    if (text && !Array.isArray(text)) {
      const stringArrayToString = text as unknown as string;
      const stringToArray: Array<string> = stringArrayToString
        .split(",")
        .filter((text: string) => {
          return text !== "";
        });
      return stringToArray;
    }

    return text;
  };

  const getArrayPictures = (...images: Array<string | null | undefined>) => {
    return images.filter((img): img is string => Boolean(img));
  };

  const result = {
    ...dataResponse.private_office,
    amenities: convertStringToArray(dataResponse.private_office?.amenities),
    extra_services: convertStringToArray(
      dataResponse.private_office?.extra_services || [],
    ),
    pictures: getArrayPictures(
      dataResponse.private_office?.picture_url,
      dataResponse.private_office?.picture_url1,
      dataResponse.private_office?.picture_url2,
      dataResponse.private_office?.picture_url3,
      dataResponse.private_office?.picture_url4,
      dataResponse.private_office?.picture_url5,
    ),
  };

  return {
    private_office: result,
  };
};
